/**
 * IndexedDB schema for offline Interaction MVP (Dexie).
 */

import Dexie from 'dexie';

export const offlineDb = new Dexie('grand_electeur_offline');

offlineDb.version(1).stores({
  interaction_drafts: 'beneficiaireId, updatedAt',
  entity_snapshots: 'beneficiaireId, updatedAt',
  outbox: '++id, beneficiaireId, status, idempotencyKey, createdAt',
  proof_blobs: 'outboxId',
});

// v2: cache the static per-CAS parcours templates so the document-parcours
// preview at questionnaire completion works in the field (no network). Dexie
// carries the v1 tables forward automatically.
offlineDb.version(2).stores({
  cas_templates: 'casNumero, updatedAt',
});

// v3 (F-35 / F-29) : chaque ligne de la file porte `ownerUserId`, l'utilisateur
// qui l'a mise en file. Ajout d'index seulement : Dexie conserve les lignes
// existantes, qui restent sans propriétaire (règle « héritée », outbox.service).
offlineDb.version(3).stores({
  outbox: '++id, beneficiaireId, status, idempotencyKey, createdAt, ownerUserId',
});

export const OUTBOX_STATUS = {
  PENDING: 'pending',
  SYNCING: 'syncing',
  SYNCED: 'synced',
  FAILED: 'failed',
  // Terminal: exceeded MAX_SYNC_ATTEMPTS. Not retried, not counted as pending —
  // surfaced to the user for manual attention instead of retrying forever.
  ERROR: 'error',
};
